// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select__Select___2TzCf"};